<template>
    <div class="col-md-12 profileDetails justify-content">
        <div>
            <img :src="this.Member?.PhotoURL ?? '/img/user-placeholder.svg'" width="200" height="200" class="pImage" :alt="'Photo of ' + this.Member.Name">                
            <div class="clr"></div>  
            <div class="position" v-if="this.Member?.Position">{{this.Member.Position}}</div>       
            <div class="profileInfo" v-html="memberDetails"></div>    
        </div>
    </div>
</template>
<script>
    export default {
        name: "MemberProfile",
        props:["Member"],
        data(){
            return{
            }
        },
        computed: {
            memberDetails: function () {
                if (this.Member?.ProfileInfo == null) {
                    return "<div></div>";
                }
                return "<div>" + this.Member?.ProfileInfo + "</div>";
            },
        }
    }
</script>